import { cn } from "@/lib/utils";
import React from "react";
import { AccordionItemProps } from "@/components/ui/accordion/accordion-item";
import Accordion from "@/components/ui/accordion/accordion";

export interface FAQsProps {
  id?: string;
  className?: string;
  heading?: string;
  items?: AccordionItemProps[];
}

const FAQs: React.FC<FAQsProps> = ({
  id = "faqs",
  className,
  heading = "FAQs",
  items = [],
}) => {
  return (
    <section
      id={id}
      aria-label={id}
      className={cn("w-full bg-neutral-100", className)}
    >
      <div className="mx-auto flex max-w-lg flex-col gap-6 p-4 md:gap-8 md:px-6 md:py-8 lg:gap-10 lg:px-3 lg:py-10">
        <h3 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-3 lg:text-heading-2">
          {heading}
        </h3>
        <Accordion items={items} />
      </div>
    </section>
  );
};

export default FAQs;
